<template>
  <div class="logincon" @click="handleClose">
    <div class="info-con login" v-if="activeTab=='login'" @click="notClose">
      <div class="reg-title">登录账号</div>
      <div class="gologin">没有账号？<span @click="goaffirm">立即注册</span></div>
      <div class="reg-info">
        <div><input placeholder="请输入手机号/中基协登记编号" v-model="mobile"/><img src="../assets/tel.png"/></div>
        <div><input type="password" placeholder="请输入密码" v-model="password"/><img src="../assets/pwd.png"/></div>
        <div class="forgetpwd" @click="forgetpwd">忘记密码</div>
        <div class="button" @click="gologin">登录</div>
      </div>
    </div>

  </div>
</template>
<script>

  import {http} from '../fetch/api'

  // import md5 from 'js-md5';
  import Utils from '@/fetch/utils'
  export default {
    data() {
      return {
        activeTab: 'login',
        mobile: '',
        verifyCode: '',
        password: ''
      }
    },
    mounted() {},
    methods: {
      async goaffirm() {
        this.$emit("goaffirm")
      },
      async forgetpwd() {

        this.$emit("goforgetpwd")
      },
      async gologin() {
        if (!this.mobile) {
          this.$store.state.noticeMessage="请输入手机号/中基协登记编号"
          // format.message("请输入账号", "error")
          return
        }
        if (!this.password) {
          this.$store.state.noticeMessage="请输入密码"
          // format.message("请输入密码", "error")
          return
        }
        var pwd=Utils.encrypt(this.password)
        // var a=Utils.decrypt(pwd)
        // console.log(a)
        var data = await http.login(this.mobile, pwd)
        if (data.code == '0') {
          // this.$set(this.GLOBAL,'loginState',true)
          // this.$forceUpdate()
          this.$store.state.loginState=true
          window.localStorage.institutId = data.data.investor.institutId
          window.localStorage.mobile = data.data.investor.mobile
          //已填写调查问卷
          // if(data.data.survey) {
            this.$emit("closelogin")
          // } else {
          //   this.$emit("gosurvey")
          // }
          // localStorage.setItem("Flag", "isLogin")
        }
      },
      handleClose() {
        this.$emit("closelogin","only")
      },
      notClose(event) {
        event.stopPropagation()
      }
    }
  }
</script>
<style scoped>
  .logincon {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 99;
  }

  .info-con {

    background-repeat: no-repeat;
    background-size: contain;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
  }

  .eligible {
    background-image: url("../assets/hgtzzrd.png");
    width: 840px;
    height: 550px;
  }

  .text {
    font-size: 16px;
    margin: 30px 70px;
    text-align: left;
  }

  .text p {
    text-indent: 32px;
    line-height: 28px;
    letter-spacing: 1px;
  }

  .buttons div {
    display: inline-block;
    width: 240px;
    margin: 0 25px;
    color: #fff;
    border-radius: 6px;
    height: 50px;
    line-height: 50px;
  }

  .gray {
    background: #b5b5b5;
  }

  .light {
    background: #00bcbc;
  }

  .login {
    background-image: url("../assets/login.png");
    width: 840px;
    height: 550px;
  }

  .two-title {

  }

  .reg-title {
    display: inline-block;
    text-align: center;
    height: 68px;
    line-height: 68px;
    color: #fff;
    font-size: 30px;
    padding: 0 20px;
    font-family: MicrosoftYaHei-Bold;
    text-shadow: 2px 2px 20px #0ff;
    letter-spacing: 6px;
  }

  .gologin {
    margin: 80px auto 0 auto;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    /*font-weight: bold;*/
    font-stretch: normal;
    text-align: right;
    width: 400px;
    color: #fff;
  }

  .gologin span {
    cursor: pointer;
    color: #0ff;
    text-decoration: underline;
  }

  .reg-info {
    width: 400px;
    margin: 0 auto;
  }

  .reg-info > div {
    position: relative;
  }

  .reg-info input {
    margin: 10px 0;
    background: #1f4661;
    width: 400px;
    height: 50px;
    border-radius: 6px;
    border: solid 1px rgba(0,255,255,.3);
    padding-left: 30px;
    box-sizing: border-box;
    outline: none;
    color: #fff;
  }
  input::input-placeholder {
    color: #c6c6c6;
  }
  input::-webkit-input-placeholder {
    color: #c6c6c6;
  }
  input::-moz-input-placeholder {
    color: #c6c6c6;
  }
  input::-ms-input-placeholder {
    color: #fff;
  }
  .reg-info img {
    position: absolute;
    left: 10px;
    vertical-align: middle;
    top: 25px;
    width: 14px;
  }

  .vercode {
    text-align: center;
    display: inline-block;
    width: 100px;
    border-left: solid 1px #0ff;
    position: absolute;
    right: 0;
    height: 40px;
    line-height: 40px;
    color: #0ff;
    margin-top: 15px;
  }

  .button {
    width: 400px;
    height: 50px;
    background-color: #00ffff;
    border-radius: 6px;
    font-family: MicrosoftYaHei;
    font-size: 20px;
    font-stretch: normal;
    line-height: 50px;
    letter-spacing: 8px;
    color: #06172f;
    margin-top: 20px;
    cursor: pointer;
  }

  .forgetpwd {
    text-align: right;
    color: #0ff;
    cursor: pointer;
    text-decoration: underline;
    font-size: 14px;
  }

  .survey {
    background-image: url("../assets/jgtzzwj.png");
    width: 1020px;
    height: 735px;
  }

  .persurvey {
    background-image: url("../assets/grtzzwj.png");
    width: 1020px;
    height: 735px;
  }

  .survey p, .persurvey p {
    text-align: left;
  }

  .scroll-con {
    height: 500px;
    overflow: scroll;
  }

  /*滚动条整体样式*/
  .scroll-con::-webkit-scrollbar {
    width: 8px;
    height: 1px;
  }

  /*滚动条滑块*/
  .scroll-con::-webkit-scrollbar-thumb {
    border-radius: 0px;
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.1);
    background: #a4f1fc;
  }

  /*滚动条轨道*/
  .scroll-con::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 10px;
    background: none;
  }

  .finish {
    width: 240px;
    background: #00bcbc;
    margin: 0 auto;
    color: #fff;
    height: 50px;
    line-height: 50px;
    border-radius: 6px;
  }

  .closebutton {
    position: absolute;
    color: #fff;
    right: 20px;
    top: -25px;
  }

  p .onlyline {
    display: block;
  }

  input[type="checkbox"] {
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue